import type { AxiosInstance } from 'axios';
import type {
  GetNotificationFeedParams,
  GetNotificationFeedResponse,
  NotificationBadge,
} from '../../constants';

/**
 * Notification feed (cursor pagination) 조회.
 */
export const getNotificationFeed = async (
  instance: AxiosInstance,
  params?: GetNotificationFeedParams,
  signal?: AbortSignal,
): Promise<GetNotificationFeedResponse> => {
  return await instance.get('/v1/notification/notifications/feed', { params, signal });
};

/**
 * Notification badge (unseenCount, lastSeenAt, latestOccurredAt) 조회.
 * @description
 * - GNB bell 배지 표시 전용 — `lastSeenAt` 기준으로 unseenCount 계산.
 */
export const getNotificationBadge = async (
  instance: AxiosInstance,
  signal?: AbortSignal,
): Promise<NotificationBadge> => {
  return await instance.get('/v1/notification/notifications/badge', { signal });
};

/**
 * GNB bell 클릭 시 호출 — 사용자의 `lastSeenAt` cursor를 갱신해서 unseenCount를 0으로 만든다.
 */
export const markNotificationsSeen = async (instance: AxiosInstance): Promise<void> => {
  return await instance.post('/v1/notification/notifications/seen');
};

/**
 * 단일 Notification 읽음 처리.
 */
export const readNotification = async (instance: AxiosInstance, id: string): Promise<void> => {
  return await instance.post(`/v1/notification/notifications/${id}/read`);
};

/**
 * 전체 Notification 읽음 처리.
 */
export const readAllNotifications = async (instance: AxiosInstance): Promise<void> => {
  return await instance.post('/v1/notification/notifications/read-all');
};
